module.exports = __webpack_public_path__ + "img/m4a1_silencer_off.ba21da0f.svg";